import { render, staticRenderFns } from "./ActUploads__track.vue?vue&type=template&id=28b2817c&scoped=true&"
import script from "./ActUploads__track.vue?vue&type=script&lang=js&"
export * from "./ActUploads__track.vue?vue&type=script&lang=js&"
import style0 from "./ActUploads__track.vue?vue&type=style&index=0&id=28b2817c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2817c",
  null
  
)

export default component.exports